import React from 'react';
import BookTime from './BookTime/BookTime';
import CuratedEngagement from './CuratedEngagement/CuratedEngagement';
import CuratedEngagementShortcut from './ScopedEngagement/CuratedEngagementShortcut';
import ScopedEngagement from './ScopedEngagement/ScopedEngagement';
import Success from './Success/Success';

const ENGAGEMENTS = {
  SCOPED: 'SCOPED',
  CURATED: 'CURATED',
};

const STAGES = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  TIME_BOOKING: 'TIME_BOOKING',
};

type CreateRequestProps = {
  onCompleted: () => void;
};

const CreateRequest = ({ onCompleted }: CreateRequestProps) => {
  const [stage, setStage] = React.useState(STAGES.IN_PROGRESS);
  const [selectedEngagement, setSelectedEngagement] = React.useState(ENGAGEMENTS.SCOPED);

  React.useEffect(() => {
    if (stage === STAGES.SUCCESS) {
      setTimeout(() => {
        setStage(STAGES.TIME_BOOKING);
      }, 2000);
    }
  }, [stage]);

  if (stage === STAGES.IN_PROGRESS) {
    return (
      <>
        {selectedEngagement === ENGAGEMENTS.SCOPED && (
          <CuratedEngagementShortcut onClick={() => setSelectedEngagement(ENGAGEMENTS.CURATED)} />
        )}
        {selectedEngagement === ENGAGEMENTS.CURATED ? (
          <CuratedEngagement
            goBack={() => setSelectedEngagement(ENGAGEMENTS.SCOPED)}
            onScheduled={() => setStage(STAGES.SUCCESS)}
          />
        ) : (
          <ScopedEngagement onCreated={() => setStage(STAGES.SUCCESS)} />
        )}
      </>
    );
  }

  if (stage === STAGES.SUCCESS) {
    return <Success />;
  }

  if (stage === STAGES.TIME_BOOKING) {
    return <BookTime onScheduled={onCompleted} />;
  }

  // Impossible, but TS doesn't know that
  return <p>Something went wrong</p>;
};

export default CreateRequest;
